import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpService } from '../../../services/help.service';
import { ExperienceManager } from '../../../managers/experience.manager';
import { NotificationManager } from '../../../managers/notification.manager';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-manage-password',
    templateUrl: './manage-password.component.html',
    styleUrls: ['./manage-password.component.scss'],
    standalone: false
})
export class ManagePasswordComponent extends BaseComponent implements OnInit, OnDestroy {
	public state: 'reset-password' | 'change-password' | 'success' = 'change-password';
	public resetPasswordFormGroup = this.formBuilder.group({
		password: [''],
		newPassword: [''],
		confirmPassword: ['']
	});
	public passwordRequirementMet: boolean = false;
	private userId: string;
	private confirmationCode: any;
	private resetCode: string;

	constructor(
		private readonly formBuilder: UntypedFormBuilder,
		private readonly authenticationService: AuthenticationService,
		private readonly helpService: HelpService,
		private readonly experienceManager: ExperienceManager,
		private readonly notificationManager: NotificationManager,
		private route: ActivatedRoute
	) {
		super();

		this.experienceManager.updateState({
			showTopBar: false
		});

		if (this.authenticationService.isLoggedIn())
			this.authenticationService.deleteToken();
	}

	ngOnDestroy() {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	ngOnInit() {

		this.route.queryParams.subscribe(({ codeNewUser, key, code }) => {
			this.confirmationCode = code;
			this.resetCode = codeNewUser || code;
			this.userId = key;

			if (codeNewUser && key) {
				this.state = 'reset-password';
			}

			if (!codeNewUser && key && code) {
				this.state = 'reset-password';
			}

		});

		this.helpService.updateHelpLink('logging-in');
	}

	public resetPassword() {
		if (!this.passwordRequirementMet)
			return;

		this.authenticationService
			.resetPasswordUsingCode(this.resetCode, this.confirmationCode, this.userId, this.resetPasswordFormGroup.value.newPassword)
			.subscribe((success) => {
				if (success) {
					this.state = 'success';
				}
			}, () => {
				this.notificationManager.displaySnackBarMessage({ message: 'Unable to reset password. Please contact Professional Services for support.', type: 'error', ttl: 10000 });
			});
	}
}
